import { QueryClient } from 'react-query';
import { MedusaCart, MyBoxSettingsQuery, OrdersQuery } from 'lib/home/generated/types/api';

const getUpdatedQuery = (query: OrdersQuery | MyBoxSettingsQuery, cart: MedusaCart) => {
  if (query?.me?.subscription?.current_order?.medusa_cart) query.me.subscription.current_order.medusa_cart = cart;
  return query;
};

export const swapMealInCurrentOrder = (queryClient: QueryClient, cart: MedusaCart) => {
  queryClient.setQueryData(['Orders'], (query: OrdersQuery) => getUpdatedQuery(query, cart));
  queryClient.setQueryData(['MyBoxSettings'], (query: MyBoxSettingsQuery) => getUpdatedQuery(query, cart));
};
